import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Spin, Row, Col, Input, InputNumber, DatePicker, Select, Radio, Descriptions, Tag, Alert, Tooltip, Checkbox, message } from "antd";
import { SafetyCertificateOutlined, CheckOutlined, CloseOutlined, FilePdfOutlined, SaveOutlined, WarningOutlined } from "@ant-design/icons";
import moment from "moment";
import { DynamicCardForm, ButtonItem, SelectEmpleadosItem } from "../../../../Components/Items";
import ModalPdfCMMS from "../componentes/ModalPdfCMMS";
import { cmmsPost, formatoFecha, fechaDiaPayload, momentFechaDia } from "../cmmsComun";
import { cumpleCelda, resultadoCertificado, resultadoOtorgado, pendientesCertificado, dictamenSugerido, textoRango, textoTolerancia, formatoNumero, sumarMeses, VIGENCIAS } from "./certificadoComun";
import { generarPdfCertificado } from "./pdfCertificado";
import "../cmms.css";

const { Option } = Select;

const idMedicion = (i, k, j) => `cmms-medicion-${i}-${k}-${j}`;

// Captura de un certificado desde su Orden de Servicio. Nuevo: props.plantillaId; existente:
// props.certificadoId. Se ve en vivo si cada medicion cumple (el backend recalcula al guardar).
// onClose(huboCambios)

const BotonesResultado = ({ value, onChange, disabled }) => (
    <Radio.Group size="small" buttonStyle="solid" value={value ?? null} disabled={disabled} onChange={(e) => onChange(e.target.value === value ? null : e.target.value)}>
        <Tooltip title="Cumple">
            <Radio.Button value={1} onClick={() => value === 1 && onChange(null)}>
                <CheckOutlined />
            </Radio.Button>
        </Tooltip>
        <Tooltip title="No cumple">
            <Radio.Button value={2} onClick={() => value === 2 && onChange(null)}>
                <CloseOutlined />
            </Radio.Button>
        </Tooltip>
        <Tooltip title="No aplica">
            <Radio.Button value={3} onClick={() => value === 3 && onChange(null)}>
                N/A
            </Radio.Button>
        </Tooltip>
    </Radio.Group>
);

class ModalCertificadoCMMS extends Component {
    state = { cargando: false, guardando: false, c: null, patrones: [], dictamenEditado: false, cambios: false, guardadoAlgunaVez: false, pdf: false };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) this.cargar();
    }

    cargar = async () => {
        this.setState({ cargando: true, c: null, cambios: false, guardadoAlgunaVez: false, dictamenEditado: false });
        try {
            const [rPatrones, rCert] = await Promise.all([
                cmmsPost(this.props, "selectEquiposPatronCMMS", { todos: true }),
                this.props.certificadoId
                    ? cmmsPost(this.props, "datosCertificadoCMMS", { id: this.props.certificadoId })
                    : cmmsPost(this.props, "prepararCertificadoCMMS", { servicioId: this.props.servicioId, plantillaId: this.props.plantillaId }),
            ]);
            if (rCert.data.success !== 2) {
                message.error(rCert.data.message || "No se pudo abrir el certificado");
                return this.props.onClose(false);
            }
            const c = rCert.data.certificado;
            // Si el resumen guardado es uno de los sugeridos (o vacio) sigue al resultado; si lo escribieron, se respeta.
            const editado = !!c._id && ![c.dictamenAprobado, c.dictamenNoAprobado, ""].includes(c.dictamen || "");
            this.setState({ c, patrones: rPatrones.data.success === 2 ? rPatrones.data.equiposPatron : [], dictamenEditado: editado });
        } catch (error) {
            console.log(error);
            message.error("No se pudo abrir el certificado");
        } finally {
            this.setState({ cargando: false });
        }
    };

    get bloqueado() {
        return this.props.bloqueado || this.state.c?.estatus === 0;
    }

    set = (cambios) => this.setState((s) => ({ c: { ...s.c, ...cambios }, cambios: true }));
    setSeccion = (i, f) => this.setState((s) => ({ c: { ...s.c, secciones: s.c.secciones.map((x, j) => (j === i ? { ...x, ...f(x) } : x)) }, cambios: true }));
    setItem = (i, k, cambios) => this.setSeccion(i, (s) => ({ items: s.items.map((it, n) => (n === k ? { ...it, ...cambios } : it)) }));
    setCelda = (i, k, j, cambios) => this.setSeccion(i, (s) => ({ filas: s.filas.map((f, n) => (n === k ? { ...f, celdas: f.celdas.map((c, m) => (m === j ? { ...c, ...cambios } : c)) } : f)) }));
    todoCumple = (i, campo) => this.setSeccion(i, (s) => ({ items: s.items.map((it) => ({ ...it, [campo]: it[campo] === 3 ? 3 : 1 })) }));

    // Lo que dan las mediciones y el checklist (sin la decision del ingeniero).
    get calculado() {
        return this.state.c ? resultadoCertificado(this.state.c.secciones) : null;
    }

    get pendientes() {
        return this.state.c ? pendientesCertificado(this.state.c.secciones) : 0;
    }

    // Resultado final: { cumple, otorgado } (otorgado = lo da por bueno aunque algo no cumpla).
    get final() {
        return resultadoOtorgado(this.calculado, this.pendientes, this.state.c?.otorgado);
    }

    get resultado() {
        return this.final.cumple;
    }

    dictamenSugerido = () => (this.state.c ? dictamenSugerido({ cumple: this.resultado, pendientes: this.pendientes, dictamenAprobado: this.state.c.dictamenAprobado, dictamenNoAprobado: this.state.c.dictamenNoAprobado }) : "");

    // Con valores pendientes se avisa: se puede guardar a medias, pero no sale como "Cumple".
    confirmarGuardar = () => {
        if (this.final.otorgado && !String(this.state.c.motivoOtorgado || "").trim()) return message.warning("Escriba por qué se otorga el certificado aunque algo no cumpla");
        const n = this.pendientes;
        if (!n) return this.guardar();
        Modal.confirm({
            title: `Faltan ${n} valor${n === 1 ? "" : "es"} por capturar`,
            content: "Se puede guardar y terminar después, pero mientras esté incompleto no saldrá como “Cumple” ni en la página pública del equipo.",
            okText: "Guardar así",
            cancelText: "Seguir capturando",
            onOk: this.guardar,
        });
    };

    guardar = async () => {
        const c = this.state.c;
        this.setState({ guardando: true });
        try {
            const res = await cmmsPost(this.props, "guardarCertificadoCMMS", {
                id: c._id,
                servicioId: c.servicioId || this.props.servicioId,
                plantillaId: c.plantillaId,
                plantillaVersion: c._id ? undefined : c.plantillaVersion,
                fecha: c.fecha,
                patronesIds: c.patronesIds,
                camposEquipo: c.camposEquipo.map((x) => ({ valor: x.valor })),
                secciones: c.secciones.map((s) => ({
                    items: s.items.map((it) => ({ antes: it.antes, despues: it.despues, observacion: it.observacion })),
                    filas: s.filas.map((f) => ({ celdas: f.celdas.map((x) => ({ establecido: x.establecido, entregado: x.entregado, valorTexto: x.valorTexto })) })),
                })),
                dictamen: this.state.dictamenEditado ? c.dictamen : this.dictamenSugerido(),
                empleadoId: c.empleadoId,
                recibio: c.recibio,
                otorgado: this.final.otorgado,
                motivoOtorgado: this.final.otorgado ? c.motivoOtorgado : "",
            });
            if (res.data.success === 2) {
                message.success(c._id ? "Certificado guardado" : `Certificado ${res.data.codigo} emitido`);
                this.setState((s) => ({ c: { ...s.c, _id: res.data.id, codigo: res.data.codigo, dictamen: res.data.dictamen ?? s.c.dictamen }, cambios: false, guardadoAlgunaVez: true }));
            } else message.error(res.data.message || "No se pudo guardar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar");
        } finally {
            this.setState({ guardando: false });
        }
    };

    cerrar = () => {
        const salir = () => this.props.onClose(this.state.guardadoAlgunaVez);
        if (!this.state.cambios || this.bloqueado) return salir();
        Modal.confirm({ title: "Hay cambios sin guardar", content: "¿Cerrar sin guardar el certificado?", okText: "Cerrar", cancelText: "Seguir capturando", onOk: salir });
    };

    // ─── Secciones ──────────────────────────────────────────────────────────

    renderChecklist(s, i) {
        const dis = this.bloqueado;
        return (
            <DynamicCardForm
                key={i}
                title={s.titulo}
                xs={24}
                headerRight={
                    !dis && (
                        <span style={{ display: "flex", gap: 4 }}>
                            <ButtonItem type="default" size="small" icon={<CheckOutlined />} onClick={() => this.todoCumple(i, "antes")}>
                                Antes: todo cumple
                            </ButtonItem>
                            <ButtonItem type="default" size="small" icon={<CheckOutlined />} onClick={() => this.todoCumple(i, "despues")}>
                                Después: todo cumple
                            </ButtonItem>
                        </span>
                    )
                }
            >
                <table className="cmms-tabla-captura">
                    <thead>
                        <tr>
                            <th style={{ textAlign: "left" }}>Característica</th>
                            <th style={{ width: 130 }}>Antes del mtto.</th>
                            <th style={{ width: 130 }}>Después del mtto.</th>
                            <th style={{ width: 260 }}>Observaciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {s.items.map((it, k) => (
                            <tr key={k} style={it.despues === 2 ? { background: "#fff1f0" } : undefined}>
                                <td>
                                    {it.grupo ? <b>{it.grupo} · </b> : null}
                                    {it.texto}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    <BotonesResultado value={it.antes} disabled={dis} onChange={(antes) => this.setItem(i, k, { antes })} />
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    <BotonesResultado value={it.despues} disabled={dis} onChange={(despues) => this.setItem(i, k, { despues })} />
                                </td>
                                <td>
                                    <Input size="small" value={it.observacion} disabled={dis} placeholder={it.antes === 2 ? "¿Qué se encontró / qué se hizo?" : ""} onChange={(e) => this.setItem(i, k, { observacion: e.target.value })} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </DynamicCardForm>
        );
    }

    renderCeldaMedicion(i, k, j, col, celda) {
        const dis = this.bloqueado;
        const cumple = cumpleCelda(col, celda);
        return [
            <td key="e" style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                {celda.establecidoEditable ? (
                    <InputNumber size="small" value={celda.establecido} disabled={dis} placeholder="Establecido" onChange={(v) => this.setCelda(i, k, j, { establecido: v ?? null })} style={{ width: 90 }} />
                ) : (
                    formatoNumero(celda.establecido)
                )}
            </td>,
            <td key="r" style={{ textAlign: "center", color: "#7a8794", whiteSpace: "nowrap" }}>
                {textoRango(col, celda)}
            </td>,
            <td key="v" style={{ whiteSpace: "nowrap" }}>
                <InputNumber
                    id={idMedicion(i, k, j)}
                    size="small"
                    value={celda.entregado}
                    disabled={dis}
                    onPressEnter={() => this.siguienteMedicion(i, k, j)}
                    onChange={(v) => this.setCelda(i, k, j, { entregado: v ?? null })}
                    className={cumple === true ? "cmms-celda-cumple" : cumple === false ? "cmms-celda-no-cumple" : ""}
                    style={{ width: 90 }}
                />{" "}
                {cumple === true ? <CheckOutlined style={{ color: "#2e9e6b" }} /> : cumple === false ? <CloseOutlined style={{ color: "#d64545" }} /> : null}
            </td>,
        ];
    }

    // Enter en "Entregado" pasa a la siguiente medicion (de la misma tabla o de la que sigue).
    siguienteMedicion = (i, k, j) => {
        const ids = [];
        this.state.c.secciones.forEach((s, a) => {
            if (s.tipo !== "tabla") return;
            (s.filas || []).forEach((f, b) => (s.columnas || []).forEach((col, d) => col.tipo === "medicion" && ids.push(idMedicion(a, b, d))));
        });
        const siguiente = document.getElementById(ids[ids.indexOf(idMedicion(i, k, j)) + 1]);
        if (!siguiente) return;
        siguiente.focus();
        siguiente.select();
    };

    renderTabla(s, i) {
        const dis = this.bloqueado;
        const columnas = s.columnas || [];
        const conMedicion = columnas.some((col) => col.tipo === "medicion");
        return (
            <DynamicCardForm key={i} title={s.titulo} xs={24} headerRight={!dis && conMedicion && <span className="cmms-ayuda-enter">Enter ↵ pasa a la siguiente medición</span>}>
                <div style={{ overflowX: "auto" }}>
                    <table className="cmms-tabla-captura">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ textAlign: "left", minWidth: 140 }}>
                                    {s.etiquetaFila || "Modo"}
                                </th>
                                {columnas.map((col, j) =>
                                    col.tipo === "medicion" ? (
                                        <th key={j} colSpan={3}>
                                            {col.nombre}
                                            {col.unidad ? ` (${col.unidad})` : ""}
                                        </th>
                                    ) : (
                                        <th key={j} rowSpan={2}>
                                            {col.nombre}
                                        </th>
                                    )
                                )}
                            </tr>
                            <tr>
                                {columnas.flatMap((col, j) =>
                                    col.tipo === "medicion"
                                        ? [
                                              <th key={`${j}e`}>Establecido</th>,
                                              <th key={`${j}r`}>Rango {textoTolerancia(col) ? `(${textoTolerancia(col)})` : ""}</th>,
                                              <th key={`${j}v`}>Entregado</th>,
                                          ]
                                        : []
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {s.filas.map((f, k) => (
                                <tr key={k}>
                                    <td>{f.etiqueta}</td>
                                    {columnas.map((col, j) => {
                                        const celda = f.celdas[j] || {};
                                        if (col.tipo === "medicion") return this.renderCeldaMedicion(i, k, j, col, celda);
                                        if (col.tipo === "okError")
                                            return (
                                                <td key={j} style={{ textAlign: "center" }}>
                                                    <Radio.Group size="small" buttonStyle="solid" value={celda.valorTexto || null} disabled={dis} onChange={(e) => this.setCelda(i, k, j, { valorTexto: e.target.value })}>
                                                        <Radio.Button value="Ok">Ok</Radio.Button>
                                                        <Radio.Button value="Error">Error</Radio.Button>
                                                    </Radio.Group>
                                                </td>
                                            );
                                        if (col.tipo === "texto")
                                            return (
                                                <td key={j} style={{ textAlign: "center" }}>
                                                    {celda.texto}
                                                </td>
                                            );
                                        return (
                                            <td key={j}>
                                                <Input size="small" value={celda.valorTexto} disabled={dis} onChange={(e) => this.setCelda(i, k, j, { valorTexto: e.target.value })} />
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </DynamicCardForm>
        );
    }

    renderEncabezado() {
        const c = this.state.c;
        const dis = this.bloqueado;
        const elegidos = this.state.patrones.filter((p) => (c.patronesIds || []).includes(p._id));
        // Los ya guardados que hoy estan deshabilitados siguen saliendo (con su copia del certificado).
        const opciones = this.state.patrones.filter((p) => p.activo || (c.patronesIds || []).includes(p._id));
        return [
            <DynamicCardForm key="datos" title="Certificado" xs={24} lg={10}>
                <Row gutter={10}>
                    <Col xs={12}>
                        <div className="cmms-etiqueta-campo">Fecha</div>
                        <DatePicker
                            format="DD/MM/YYYY"
                            allowClear={false}
                            disabled={dis}
                            style={{ width: "100%" }}
                            value={momentFechaDia(moment, c.fecha)}
                            onChange={(m) => m && this.set({ fecha: fechaDiaPayload(m) })}
                        />
                    </Col>
                    <Col xs={12}>
                        <div className="cmms-etiqueta-campo">Vigente hasta</div>
                        <div style={{ paddingTop: 5, fontWeight: 600 }}>
                            {c.fecha ? momentFechaDia(moment, sumarMeses(c.fecha, c.vigenciaMeses || 6)).format("DD/MM/YYYY") : ""} <span style={{ color: "#7a8794", fontWeight: 400 }}>({c.vigenciaMeses || 6} meses)</span>
                        </div>
                    </Col>
                    <Col xs={24} style={{ marginTop: 8 }}>
                        <div className="cmms-etiqueta-campo">Ingeniero que certifica</div>
                        <SelectEmpleadosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} width="100%" disabled={dis} value={c.empleadoId || undefined} onChange={(empleadoId) => this.set({ empleadoId: empleadoId || null })} />
                    </Col>
                    <Col xs={24} style={{ marginTop: 8 }}>
                        <div className="cmms-etiqueta-campo">Recibió (nombre)</div>
                        <Input value={c.recibio} disabled={dis} placeholder="Quién recibe en el área usuaria" onChange={(e) => this.set({ recibio: e.target.value })} />
                    </Col>
                </Row>
            </DynamicCardForm>,
            <DynamicCardForm key="patron" title={c.etiquetaPatron || "Equipo patrón"} xs={24} lg={14}>
                <Select mode="multiple" allowClear showSearch optionFilterProp="children" style={{ width: "100%" }} disabled={dis} placeholder="Elija el simulador / analizador" value={c.patronesIds || []} onChange={(patronesIds) => this.set({ patronesIds })}>
                    {opciones.map((p) => (
                        <Option key={p._id} value={p._id}>
                            {p.nombre}
                        </Option>
                    ))}
                </Select>
                {!opciones.length && <div className="cmms-ayuda" style={{ marginTop: 6 }}>No hay equipos patrón: dé de alta los suyos en CMMS › Certificados › Equipos patrón.</div>}
                {elegidos.map((p) => (
                    <div key={p._id} style={{ marginTop: 6, fontSize: 12 }}>
                        <b>{p.nombre}</b> · Certificado {p.certificado || "—"} · Calibración {formatoFecha(p.fechaCalibracion) || "—"}
                        {p.estatusCalibracion === "vencido" ? (
                            <Tag color="red" icon={<WarningOutlined />} style={{ marginLeft: 6 }}>
                                Calibración vencida
                            </Tag>
                        ) : p.estatusCalibracion ? (
                            <Tag color={VIGENCIAS[p.estatusCalibracion].color} style={{ marginLeft: 6 }}>
                                {VIGENCIAS[p.estatusCalibracion].label} {formatoFecha(p.proximaCalibracion)}
                            </Tag>
                        ) : null}
                    </div>
                ))}
            </DynamicCardForm>,
            <DynamicCardForm key="equipo" title="Equipo y cliente" xs={24}>
                <Descriptions size="small" column={{ xs: 1, md: 3 }} labelStyle={{ fontWeight: 500 }}>
                    <Descriptions.Item label="Equipo">{[c.equipo?.codigo, c.equipo?.tipo].filter(Boolean).join(" · ")}</Descriptions.Item>
                    <Descriptions.Item label="Marca / modelo">{[c.equipo?.marca, c.equipo?.modelo].filter(Boolean).join(" · ")}</Descriptions.Item>
                    <Descriptions.Item label="No. serie">{c.equipo?.numeroSerie || "—"}</Descriptions.Item>
                    <Descriptions.Item label="Cliente">{c.clienteNombre || "—"}</Descriptions.Item>
                    <Descriptions.Item label="Dirección" span={2}>
                        {c.clienteDireccion || "—"}
                    </Descriptions.Item>
                </Descriptions>
                {(c.camposEquipo || []).length > 0 && (
                    <Row gutter={10} style={{ marginTop: 6 }}>
                        {c.camposEquipo.map((campo, i) => (
                            <Col xs={24} md={8} key={i}>
                                <div className="cmms-etiqueta-campo">{campo.etiqueta}</div>
                                {campo.opciones?.length ? (
                                    <Select allowClear style={{ width: "100%" }} disabled={dis} value={campo.valor || undefined} onChange={(valor) => this.set({ camposEquipo: c.camposEquipo.map((x, j) => (j === i ? { ...x, valor: valor || "" } : x)) })}>
                                        {campo.opciones.map((o) => (
                                            <Option key={o} value={o}>
                                                {o}
                                            </Option>
                                        ))}
                                    </Select>
                                ) : (
                                    <Input value={campo.valor} disabled={dis} onChange={(e) => this.set({ camposEquipo: c.camposEquipo.map((x, j) => (j === i ? { ...x, valor: e.target.value } : x)) })} />
                                )}
                            </Col>
                        ))}
                    </Row>
                )}
            </DynamicCardForm>,
        ];
    }

    // Algo no cumple: el ingeniero puede otorgarlo de todos modos (sale "Cumple con observaciones"
    // y su motivo impreso). Lo que no cumplió sigue marcado en rojo en el certificado.
    renderOtorgar() {
        const c = this.state.c;
        const dis = this.bloqueado;
        return (
            <div className="cmms-otorgar">
                <Checkbox checked={!!c.otorgado} disabled={dis} onChange={(e) => this.set({ otorgado: e.target.checked })}>
                    <b>Otorgar el certificado aunque algo no cumpla</b>
                </Checkbox>
                <div className="cmms-ayuda" style={{ margin: "2px 0 0 24px" }}>
                    Sale como “Cumple con observaciones” (y en la página pública del equipo, al estar completo). Lo que no cumplió sigue marcado en rojo y su motivo se imprime.
                </div>
                {c.otorgado && (
                    <Input.TextArea
                        rows={2}
                        maxLength={500}
                        disabled={dis}
                        style={{ marginTop: 6 }}
                        placeholder="¿Por qué se otorga? Ej. La fuga a chasis salió alta por la instalación eléctrica del área; el equipo funciona correctamente."
                        value={c.motivoOtorgado}
                        onChange={(e) => this.set({ motivoOtorgado: e.target.value })}
                    />
                )}
            </div>
        );
    }

    render() {
        const c = this.state.c;
        const resultado = this.resultado;
        const dis = this.bloqueado;
        return (
            <>
                <Modal
                    className="cmms-modal"
                    visible={this.props.visible}
                    onCancel={this.cerrar}
                    width={window.innerWidth > 1240 ? 1180 : "98%"}
                    centered
                    maskClosable={false}
                    title={
                        <div className="cmms-modal-titulo">
                            <SafetyCertificateOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                            <div>
                                <div className="cmms-modal-titulo-texto">
                                    {c?.codigo ? `Certificado ${c.codigo}` : "Nuevo certificado"} {c?.nombre ? `· ${c.nombre}` : ""}
                                </div>
                                <div className="cmms-modal-subtitulo">
                                    {[c?.clave, c?.servicioCodigo && `Orden de servicio ${c.servicioCodigo}`].filter(Boolean).join(" · ")}
                                </div>
                            </div>
                        </div>
                    }
                    footer={
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                            <span>
                                {resultado === true ? (
                                    <Tag color="green" icon={<CheckOutlined />} style={{ fontSize: 13, padding: "3px 10px" }}>
                                        {this.final.otorgado ? "Cumple con observaciones" : "Cumple"}
                                    </Tag>
                                ) : resultado === false ? (
                                    <Tag color="red" icon={<CloseOutlined />} style={{ fontSize: 13, padding: "3px 10px" }}>
                                        No cumple
                                    </Tag>
                                ) : (
                                    <Tag style={{ fontSize: 13, padding: "3px 10px" }}>{this.pendientes ? "Incompleto" : "Sin rangos"}</Tag>
                                )}
                                {c && this.pendientes > 0 && <span style={{ color: "#b4581c", fontSize: 12 }}>Faltan {this.pendientes} valor{this.pendientes === 1 ? "" : "es"} por capturar</span>}
                            </span>
                            <span style={{ display: "flex", gap: 8 }}>
                                <ButtonItem type="default" onClick={this.cerrar}>
                                    Cerrar
                                </ButtonItem>
                                <Tooltip title={this.state.cambios ? "Guarde primero" : ""}>
                                    <ButtonItem type="default" icon={<FilePdfOutlined />} disabled={!c?._id || this.state.cambios} onClick={() => this.setState({ pdf: true })}>
                                        Descargar PDF
                                    </ButtonItem>
                                </Tooltip>
                                {!dis && (
                                    <ButtonItem type="primary" icon={<SaveOutlined />} loading={this.state.guardando} disabled={!c} onClick={this.confirmarGuardar}>
                                        {c?._id ? "Guardar" : "Emitir certificado"}
                                    </ButtonItem>
                                )}
                            </span>
                        </div>
                    }
                >
                    <Spin spinning={this.state.cargando}>
                        <div className="cmms-modal-cuerpo" style={{ maxHeight: "72vh", overflowY: "auto" }}>
                            {c?.estatus === 0 && <Alert type="error" showIcon style={{ marginBottom: 10 }} message={`Certificado cancelado: ${c.motivoCancelacion || ""}`} />}
                            {c && (
                                <Row gutter={14}>
                                    {this.renderEncabezado()}
                                    {c.secciones.map((s, i) => (s.tipo === "tabla" ? this.renderTabla(s, i) : this.renderChecklist(s, i)))}
                                    <DynamicCardForm
                                        title="Resumen del estado"
                                        xs={24}
                                        headerRight={
                                            !dis &&
                                            this.state.dictamenEditado && (
                                                <ButtonItem type="link" size="small" onClick={() => this.setState((s) => ({ c: { ...s.c, dictamen: this.dictamenSugerido() }, dictamenEditado: false, cambios: true }))}>
                                                    Usar el texto sugerido
                                                </ButtonItem>
                                            )
                                        }
                                    >
                                        {this.calculado === false && this.renderOtorgar()}
                                        <Input.TextArea
                                            rows={3}
                                            disabled={dis}
                                            value={this.state.dictamenEditado ? c.dictamen : this.dictamenSugerido()}
                                            onChange={(e) => this.setState((s) => ({ c: { ...s.c, dictamen: e.target.value }, dictamenEditado: true, cambios: true }))}
                                        />
                                        {!this.state.dictamenEditado && <div className="cmms-ayuda" style={{ marginTop: 4 }}>Se ajusta solo según el resultado. Si lo edita, se queda como lo escriba.</div>}
                                    </DynamicCardForm>
                                </Row>
                            )}
                        </div>
                    </Spin>
                </Modal>
                <ModalPdfCMMS
                    visible={this.state.pdf}
                    titulo={`Certificado ${c?.codigo || ""}`}
                    nombreArchivo={`Certificado_${c?.codigo || ""}.pdf`}
                    generar={() => generarPdfCertificado(this.props, c._id)}
                    onClose={() => this.setState({ pdf: false })}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalCertificadoCMMS);
